import { Routes } from '@angular/router';
import { AuthenticatedGuard } from '@core/guard/authenticated.guard';
import { EquipmentsComponent } from './equipments.component';
var ɵ0 = { title: 'CORE.SERVICES.NAVIGATION.EQUIPMENTS.TITLE' };
var routes = [
    {
        path: 'equipamentos',
        component: EquipmentsComponent,
        canActivate: [AuthenticatedGuard],
        data: ɵ0
    }
];
var EquipmentsModule = /** @class */ (function () {
    function EquipmentsModule() {
    }
    return EquipmentsModule;
}());
export { EquipmentsModule };
export { ɵ0 };
